import { useEffect } from "react";
import { resolveModuleDisplayName } from "../constants/moduleDisplayName";
import { useGlobalConfig } from "./useGlobalConfig";

/**
 * User-facing module label from `/global/config` `module_display_name`,
 * with static fallback. Also syncs `document.title` when the value is known.
 */
export function useModuleDisplayName(): string {
  const { config } = useGlobalConfig();
  const displayName = resolveModuleDisplayName(config?.module_display_name);

  useEffect(() => {
    document.title = displayName;
  }, [displayName]);

  return displayName;
}
